import styled from 'styled-components'
import { ReactComponent as FolderClosedIcon } from 'icons/folder-closed-16.svg'

export const Bold = styled.b`
  color: ${({ theme }) => theme.colors.text.dark.base};
  font-weight: 500;
`

export const FolderIcon = styled(FolderClosedIcon)`
  height: 1rem;
`

export const CenterIconText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
`
